var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C5.58214 2 2 5.58214 2 10C2 14.4179 5.58214 18 10 18C14.4179 18 18 14.4179 18 10C18 5.58214 14.4179 2 10 2ZM13.4554 7.3875L9.69464 12.6018C9.64208 12.6751 9.57279 12.7349 9.49251 12.7762C9.41224 12.8174 9.32329 12.8389 9.23304 12.8389C9.14279 12.8389 9.05384 12.8174 8.97356 12.7762C8.89328 12.7349 8.82399 12.6751 8.77143 12.6018L6.54464 9.51607C6.47679 9.42143 6.54464 9.28929 6.66071 9.28929H7.49821C7.68036 9.28929 7.85357 9.37679 7.96071 9.52679L9.23214 11.2911L12.0393 7.39821C12.1464 7.25 12.3179 7.16071 12.5018 7.16071H13.3393C13.4554 7.16071 13.5232 7.29286 13.4554 7.3875Z",
    fill: "#00C334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.03c8390fb8f4e2d02e002943c6843955.svg";
export { ForwardRef as ReactComponent };